import { useEffect } from 'react';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Container } from 'reactstrap';
import styles from './styles.module.scss';
import clsx from 'classnames';
import PropTypes from 'prop-types';
import EditableImage from '@/components/EditableImage';
import EditableText from '@/components/EditableText';
import ArrowIcon from '/public/site-assets/svg/arrow-pointing-1.svg';

export default function FocusTextTab({
  className,
  global,
  pathPrefix,
  heading,
  content,
  button_cta_link,
  button_cta_title,
  imageURL,
  video
}) {
  useEffect(() => {
    Fancybox.bind("[data-fancybox='video']", {
      video: {
        autoStart: true,
      },
    });

    return () => {
      Fancybox.destroy();
    };
  }, []);

  return (
    <>
      <section className={clsx(className, styles.root)}>
        <Container>
          <div className="position-relative">
            <div className="wrapper offset-lg-6">
              <span className="position-absolute pointing-arrow">
                <ArrowIcon />
              </span>
              <div className="position-relative">
                {imageURL && (
                  <EditableImage
                    className={``}
                    img={{
                      path: `${pathPrefix}.image`,
                      src: `${imageURL ? imageURL : '/images/placeholders/form-img-placeholder.png'}`,
                    }}
                    size={'x75'}
                    alt={``}
                    height={`auto`}
                  />
                )}
                {heading && (
                  <EditableText
                    content={heading}
                    path={`${pathPrefix}.heading`}
                    global={global}
                    tag={`div`}
                    className={`h3`}
                  />
                )}
                {content && (
                  <EditableText
                    content={content}
                    path={`${pathPrefix}.content`}
                    global={global}
                    tag={`div`}
                    className={`content py-4`}
                    html={true}
                  />
                )}
                {video ? (
                  <a
                    href={video}
                    data-fancybox="video"
                    className={`primaryBtn m-0`}
                  >
                    {button_cta_title}
                  </a>
                ) : (
                  <Link href={`${button_cta_link}`} className={`primaryBtn m-0`}>
                    {button_cta_title}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

FocusTextTab.defaultProps = {
  pathPrefix: '',
  className: 'position-relative z-index-1',
};

FocusTextTab.propTypes = {
  pathPrefix: PropTypes.string,
  className: PropTypes.string,
  video: PropTypes.string, // Expecting a string for video URL
};
